export default {
  shipments: {},
  multipleShipmentsCounter: 0,
}
